<ng-container *ngrxLet="listLoaded$ as listLoaded">
  <ng-container *ngrxLet="questionLoaded$ as questionLoaded">
    <header class="settings-header">
      <div class="settings-header-main">
        <h2 class="settings-title">{{ 'Question Library' | translate }}</h2>
        <p class="settings-subtitle">{{ 'Manage the questions you can send to candidates' | translate }}</p>
      </div>
      <div class="settings-actions">
        <e11-button
          [disabled]="formVisible"
          [color]="'primary-accent'"
          [icon]="'add'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          [size]="'sm'"
          (click)="addQuestion()"
          value="{{ 'Add Question' | translate }}"
        >
        </e11-button>
      </div>
    </header>

    <e11-confirmation
      #confirmation
      confirmTitle="{{ 'Delete this question' | translate }}"
      confirmText="{{ 'confirm' | translate }}"
      [closeOnEscape]="false"
      cancelText="{{ 'cancel' | translate }}"
      [backdropStyle]="'dark'"
      (answer)="confirmationAnswer($event)"
    >
      {{ 'Are you sure you want to delete this question? This will not delete the question from wherever it is in use.' | translate }}
    </e11-confirmation>

    <!-- The add/edit form opens inline above the list; it carries its own card now that the page has no panel. -->
    <div
      #formContainer
      id="form-container"
      [ngClass]="{ 'question-form-card e11-z-1 e11-opacity-100': formVisible, 'e11-z-[-1] e11-opacity-0 e11-m-0 e11-relative e11-h-0': !formVisible }"
    >
      <ui-interview-question-form
        *ngIf="formVisible"
        [selectedQuestion]="selectedQuestion || undefined"
        (closeForm)="toggleCollapse()"
        (questionSubmitted)="questionSubmitted($event)"
        (questionDeleted)="questionDeleted($event)"
      >
      </ui-interview-question-form>
    </div>

    <ng-container *ngrxLet="questions$ as questions">
      <div class="search-row">
        <div class="settings-search">
          <span class="material-icons-outlined settings-search-icon" aria-hidden="true">search</span>
          <input
            type="search"
            class="settings-search-input"
            autocomplete="off"
            [placeholder]="'Search' | translate"
            [attr.aria-label]="'Search' | translate"
            (input)="testSearchInput($event)"
          />
        </div>
        <p class="result-count">{{ questions.length + ' results' | translate }}</p>
      </div>

      <div *ngIf="!listLoaded && questions.length === 0">
        <div *ngFor="let q of 8 | range">
          <ui-interview-question-skeleton></ui-interview-question-skeleton>
        </div>
      </div>

      <div *ngIf="listLoaded && questions.length === 0">
        <e11-empty-state
          [icon]="'library_books'"
          [iconSize]="'md-36'"
          [clickable]="!formVisible"
          title="{{ 'No Interview Questions' | translate }}"
          subtitle="{{ 'It appears that there are no interview questions entered yet.' | translate }}"
          (click)="addQuestion()"
        >
        </e11-empty-state>
      </div>

      <div *ngIf="!questionLoaded">
        <ui-interview-question-skeleton></ui-interview-question-skeleton>
      </div>

      <div *ngIf="questions.length" class="settings-table-wrap">
        <table class="settings-table settings-table--static">
          <thead>
            <tr>
              <th scope="col" class="col-question">{{ 'Question' | translate }}</th>
              <th scope="col" class="col-fit">{{ 'Type' | translate }}</th>
              <th scope="col" class="col-fit">{{ 'Author' | translate }}</th>
              <th scope="col" class="col-fit">{{ 'Updated' | translate }}</th>
              <th scope="col" class="col-fit">
                <span class="e11-sr-only">{{ 'Edit' | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let question of questions">
              <td class="col-question">
                <div class="row-name">{{ question.question | translate }}</div>
              </td>
              <td class="col-fit">
                <span class="type-cell">
                  <ng-container *ngIf="question.inputType === QuestionType.EssayOrVideo; else singleIcon">
                    <span class="material-icons-outlined" aria-hidden="true">article</span>
                    <span class="material-icons-outlined" aria-hidden="true">videocam</span>
                  </ng-container>
                  <ng-template #singleIcon>
                    <span class="material-icons-outlined" aria-hidden="true">{{
                      question.inputType === QuestionType.Video ? 'videocam' : 'article'
                    }}</span>
                  </ng-template>
                  {{ question.inputType | questionInputType | translate }}
                </span>
              </td>
              <td class="col-fit">{{ question.authorName }}</td>
              <td class="col-fit">{{ question.__updatedAt | date : 'MMM dd yyyy ' }}</td>
              <td class="col-fit actions-cell">
                <span class="material-icons-outlined edit-icon edit-icon--action" (click)="editQuestion(question)">edit</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
